import React, { useContext } from "react";
import {
  VisibilityContext,
  publicApiType,
} from "react-horizontal-scrolling-menu";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import styles from "./arrow.module.scss";

export function LeftArrow() {
  const visibility = useContext(VisibilityContext);

  return (
    <Arrow onClick={() => visibility.scrollPrev()} direction="left">
      Left
    </Arrow>
  );
}

export function RightArrow() {
  const visibility = useContext(VisibilityContext);

  return (
    <Arrow onClick={() => visibility.scrollNext()} direction="right">
      Right
    </Arrow>
  );
}

function Arrow({ children, direction, onClick }) {
  return direction === "left" ? (
    <LeftOutlined
      onClick={onClick}
      className={`${styles.arrow} ${styles.left}`}
    >
      {children}
    </LeftOutlined>
  ) : (
    <RightOutlined
      onClick={onClick}
      className={`${styles.arrow} ${styles.right}`}
    >
      {children}
    </RightOutlined>
  );
}
